import DwchatRoom from './dwchat_room';
import DwchatAddRoom from './dwchat_add_room';
import DwchatUserSettings from './dwchat_user_settings';
import { get_rooms, mark_message_read } from './dwchat_utils';

export default class DwchatList {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.user = opts.user;
    this.user_email = opts.user_email;
    this.is_admin = opts.is_admin;
    this.setup();
  }

  setup() {
    this.$dwchat_list = $(document.createElement('div'));
    this.$dwchat_list.addClass('dwchat-list');
    this.setup_header();
    this.setup_search();
    this.fetch_and_setup_rooms();
    this.setup_socketio();
  }

  setup_header() {
    const dwchat_list_header_html = `
			<div class='dwchat-list-header'>
				<h3>${__('Dwchats')}</h3>
        <div class='dwchat-list-icons'>
          <div class='add-room' 
            title='Create Private Room'>
            ${frappe.utils.icon('users', 'md')}
          </div>
          <div class='user-settings' 
          title='Settings'>
          ${frappe.utils.icon('setting-gear', 'md')}
          </div>
        </div>
			</div>
		`;
    this.$dwchat_list.append(dwchat_list_header_html);
  }

  setup_search() {
    const dwchat_list_search_html = `
		<div class='dwchat-search'>
			<div class='input-group'>
				<input class='form-control dwchat-search-box'
				type='search' 
				placeholder='${__('Search conversation')}'
				>	
				<span class='search-icon'>
					${frappe.utils.icon('search', 'sm')}
				</span>
			</div>
		</div>
		`;
    this.$dwchat_list.append(dwchat_list_search_html);
  }

  async fetch_and_setup_rooms() {
    try {
      const res = await get_rooms(this.user_email);
      this.rooms = res;
      this.setup_rooms();
      this.render_messages();
    } catch (error) {
      frappe.msgprint({
        title: __('Error'),
        message: __('Something went wrong. Please refresh and try again.'),
      });
    }
  }

  setup_rooms() {
    this.$dwchat_rooms_container = $(document.createElement('div'));
    this.$dwchat_rooms_container.addClass('dwchat-rooms-container');
    this.dwchat_rooms = [];

    this.rooms.forEach((element) => {
      let profile = {
        user: this.user,
        user_email: this.user_email,
        last_message: element.last_message,
        last_date: element.modified,
        is_admin: this.is_admin,
        room: element.name,
        is_read: element.is_read,
        room_name: element.room_name,
        room_type: element.type,
        opposite_person_email: element.opposite_person_email,
      };

      this.dwchat_rooms.push([
        profile.room,
        new DwchatRoom({
          $wrapper: this.$wrapper,
          $dwchat_rooms_container: this.$dwchat_rooms_container,
          dwchat_list: this,
          element: profile,
        }),
      ]);
    });
    this.$dwchat_list.append(this.$dwchat_rooms_container);
  }

  fitler_rooms(query) {
    for (const room of this.dwchat_rooms) {
      const txt = room[1].profile.room_name.toLowerCase();
      if (txt.includes(query)) {
        room[1].$dwchat_room.show();
      } else {
        room[1].$dwchat_room.hide();
      }
    }
  }

  create_new_room(profile) {
    this.dwchat_rooms.unshift([
      profile.room,
      new DwchatRoom({
        $wrapper: this.$wrapper,
        $dwchat_rooms_container: this.$dwchat_rooms_container,
        dwchat_list: this,
        element: profile,
      }),
    ]);
    this.dwchat_rooms[0][1].render('prepend');
  }

  setup_events() {
    const me = this;
    $('.dwchat-search-box').on('input', function (e) {
      me.fitler_rooms($(this).val().toLowerCase());
    });

    $('.add-room').on('click', function (e) {
      if (typeof me.dwchat_add_room_modal === 'undefined') {
        me.dwchat_add_room_modal = new DwchatAddRoom({
          user: me.user,
          user_email: me.user_email,
        });
      }
      me.dwchat_add_room_modal.show();
    });

    $('.user-settings').on('click', function (e) {
      if (typeof me.dwchat_user_settings === 'undefined') {
        me.dwchat_user_settings = new DwchatUserSettings();
      }
      me.dwchat_user_settings.show();
    });
  }

  render_messages() {
    this.$dwchat_rooms_container.empty();
    for (const element of this.dwchat_rooms) {
      element[1].render('append');
    }
  }

  render() {
    this.$wrapper.html(this.$dwchat_list);
    this.setup_events();
  }

  move_room_to_top(dwchat_room_item) {
    this.dwchat_rooms = [
      dwchat_room_item,
      ...this.dwchat_rooms.filter((item) => item !== dwchat_room_item),
    ];
  }

  setup_socketio() {
    const me = this;
    frappe.realtime.on('latest_dwchat_updates', function (res) {
      //Find the room with the specified room id
      const dwchat_room_item = me.dwchat_rooms.find(
        (element) => element[0] === res.room
      );

      if (typeof dwchat_room_item === 'undefined') {
        return;
      }

      if (
        !$('.dwchat-element').is(':visible') &&
        frappe.Dwchat.settings.user.enable_notifications === 1
      ) {
        frappe.utils.play_sound('dwchat-notification');
      }

      const message =
        res.content.length > 24
          ? res.content.substring(0, 24) + '...'
          : res.content;

      dwchat_room_item[1].set_last_message(message, res.creation);

      if ($('.dwchat-list').length) {
        dwchat_room_item[1].set_as_unread();
        dwchat_room_item[1].move_to_top();
        me.move_room_to_top(dwchat_room_item);
      } else if ($('.dwchat-space').length) {
        mark_message_read(res.room);
      }
    });

    frappe.realtime.on('new_room_creation', function (res) {
      if (
        !$('.dwchat-element').is(':visible') &&
        frappe.Dwchat.settings.user.enable_notifications === 1
      ) {
        frappe.utils.play_sound('dwchat-notification');
      }

      res.user = me.user;
      res.is_admin = me.is_admin;
      res.user_email = me.user_email;
      me.create_new_room(res);
    });

    frappe.realtime.on('dwchat_private_room_creation', function (res) {
      if (
        !$('.dwchat-element').is(':visible') &&
        frappe.Dwchat.settings.user.enable_notifications === 1
      ) {
        frappe.utils.play_sound('dwchat-notification');
      }

      if (res.members.includes(me.user_email)) {
        if (res.room_type === 'Direct') {
          res.room_name =
            res.member_names[0]['email'] == me.user_email
              ? res.member_names[1]['name']
              : res.member_names[0]['name'];

          res.opposite_person_email =
            res.member_names[0]['email'] == me.user_email
              ? res.member_names[1]['email']
              : res.member_names[0]['email'];
        }

        res.user = me.user;
        res.is_admin = me.is_admin;
        res.user_email = me.user_email;
        me.create_new_room(res);
      }
    });
  }
}